// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__22nqC","select":"Header_select__2_ifD","clinic":"Header_clinic__-L536"};